/**
 * TODO:
 * 1. Make a GET req to https://bitbns.com/order/getOTPToken to get a token
 * * Use that token to connect to socket one time at this endpoint
 * * https://wsorder.bitbns.com/?token=SOJz5gKEeZIIZYWGaHOkxKRVF_2
 * * This socket will give you notifications real time . No need to get call that notifications api
 * * On connect it gives last 20 notifications with key "data"
 */

import React, { useState, memo } from 'react';
import { connect } from 'unistore/react';
import { Trans } from 'react-i18next';
import { t } from 'i18next';
// import { withRouter } from 'react-router-dom';
// import { toast } from 'react-toastify';

import IntentModal from '@components/IntentModal';
import { Button } from '@components/Button';
import { withToast } from '@components/ToastNotifyHOC';

import { userAlertActions } from '@utils/store/actions';
import { hasOwn } from '@utils/customLib';
import { checkNGetTradeCoin, isMarginCoin } from '@utils/params';
import { getFDReturnForCoin, isFDCoin } from '@utils/storeUtils';

import { alertColors } from '../common';
import { getAppropMsg } from './alerts-row';

let lastReadUserAlert = -1;
// let notifShown = false;
let toastShown = false;
let depoCoin = '';
let depoAmt = '';
let depoAction = 0;
let depoLogId = null;

const depoActionItems = (coin, country) => {
	const lowerCoin = coin.toLowerCase();

	const intentContents = [];
	if (lowerCoin === 'fee') {
		intentContents.push({
			icon: 'https://bitbns.com/assets/img/trade1.svg',
			heading: t('Trade'),
			content: t('depositNotifModal.fee'),
			link: {
				text: t('tradeNow'),
				type: 0,
				url: '/btc',
			},
		});
	}

	const coinWithMarket = checkNGetTradeCoin(coin);

	if (coinWithMarket) {
		let cashoutContent = t(
			'depositNotifModal.coinWithMarket.cashout.content'
		);
		const cashoutLink = `/${coinWithMarket}`;
		const cashoutLinkText = t('sellNow');

		if (coinWithMarket.endsWith('-usdt')) {
			cashoutContent = t(
				'depositNotifModal.coinWithMarket.cashout.contentUsdt'
			);
		}
		// if (lowerCoin === 'usdt') {
		// 	cashoutContent =
		// 		"Withdraw USDT in INR. No tips. It's faster than usual INR withdrawal.";
		// 	cashoutLink = `/wallets/withdraw/p2p/usdt/${country}`;
		// 	cashoutLinkText = 'Withdraw Now';
		// }
		intentContents.push(
			{
				icon: 'https://bitbns.com/assets/img/trade1.svg',
				heading: t('Trade'),
				content: t('depositNotifModal.coinWithMarket.trade.content'),
				link: {
					text: t('tradeNow'),
					type: 0,
					url: cashoutLink,
				},
			},
			{
				icon: 'https://bitbns.com/assets/img/cashout1.svg',
				heading: t('depositNotifModal.coinWithMarket.cashout.heading'),
				content: cashoutContent,
				link: {
					text: cashoutLinkText,
					type: 0,
					url: cashoutLink,
				},
			}
		);
	}

	if (isFDCoin(lowerCoin)) {
		intentContents.push({
			icon: 'https://bitbns.com/assets/img/appIcons/return.png',
			heading: t('Fixed Deposits'),
			content: (
				<Trans i18nKey="depositNotifModal.fd.content">
					Invest your crypto for a fixed period of time and get upto{' '}
					<b>
						{{
							returns: getFDReturnForCoin(lowerCoin),
						}}
						% returns
					</b>
					.
				</Trans>
			),
			link: {
				type: 0,
				url: '/fixed-deposits/',
				text: t('earnNow'),
			},
		});
	}

	if (isMarginCoin(lowerCoin)) {
		intentContents.push({
			icon: 'https://bitbns.com/assets/img/hold1.svg',
			heading: t('depositNotifModal.lend.heading'),
			content: t('depositNotifModal.lend.content'),
			link: {
				text: t('lendNow'),
				type: 0,
				url: `/margin-trades/${lowerCoin}`,
			},
		});
	}

	if (lowerCoin === 'usdt' || lowerCoin === 'inr' || lowerCoin === 'try') {
		intentContents.push({
			icon: 'https://bitdroplet.com/assets/img/logos/icon-128x128.png',
			heading: t('depositNotifModal.sip.heading'),
			content: t('depositNotifModal.sip.content'),
			link: {
				text: t('depositNotifModal.sip.btn'),
				type: 1,
				url: 'https://bitdroplet.com/?utm_source=bitbns&utm_medium=web&utm_campaign=usdtDepositIntent',
			},
		});
	}

	return intentContents;
};

const UserAlertsControlCenter = connect(
	'userAlertsCount, userAlertsLastRead, userAlertLastShown, userAlertsMuted, userAlerts, tabInFocus, selectedCountry',
	userAlertActions
)(
	withToast(
		memo(
			({
				__setUserAlertLastShown,
				userAlertsCount,
				userAlerts,
				userAlertsLastRead,
				notify,
				userAlertsMuted,
				userAlertLastShown,
				tabInFocus,
				openForYouTab,
				// history,
				selectedCountry,
				__setUserAlertsRead,
			}) => {
				const [depoActionModal, depoActionModalStateChanger] =
					useState(true);
				const firstUserAlert = userAlerts[0];
				const firstAlertTime =
					firstUserAlert &&
					hasOwn(firstUserAlert, 'time') &&
					new Date(firstUserAlert.time).getTime() / 1000;

				try {
					if (
						!userAlertsMuted &&
						firstUserAlert &&
						hasOwn(firstUserAlert, 'log_id') &&
						String(userAlertLastShown) !==
							String(firstUserAlert.log_id) &&
						userAlertsLastRead < firstAlertTime &&
						lastReadUserAlert < firstAlertTime
					) {
						const {
							actions: action,
							coinStr,
							market,
							trade_amt,
							rate,
							type,
							log_id,
							order_id,
						} = firstUserAlert;
						const {
							alertType,
							title,
							text,
							icon,
							hasIntent,
							// links,
						} = getAppropMsg(
							order_id,
							action,
							coinStr,
							market,
							trade_amt,
							rate,
							type,
							selectedCountry
						);
						if (coinStr) {
							const upperCoin = coinStr.toUpperCase();
							if (!toastShown && tabInFocus) {
								toastShown = true;
							}
							// const newDepositAlert = userAlerts.find((el, index) => {
							// 	const elTime =
							// 		hasOwn(el, 'time') &&
							// 		new Date(el.time).getTime() / 1000;
							// 	return (
							// 		String(userAlertLastShown) !==
							// 			String(el.log_id) &&
							// 		elTime > userAlertsLastRead &&
							// 		elTime > lastReadUserAlert &&
							// 		el.actions === 6 &&
							// 		el.coinStr !== 'INR' &&
							// 		index !== 0
							// 	);
							// });

							if (
								action === 6 &&
								upperCoin !== 'INR' &&
								upperCoin !== 'TRY'
							) {
								depoAction = action;
								depoCoin = upperCoin;
								depoAmt = trade_amt;
								depoLogId = log_id;
							}
							// if (typeof newDepositAlert !== 'undefined') {
							// 	depoCoin = newDepositAlert.coinStr.toUpperCase();
							// 	depoAmt = newDepositAlert.trade_amt;
							// 	depoAction = newDepositAlert.actions;
							// 	depoLogId = newDepositAlert.log_id;
							// 	hasDepoSomewhere = true;
							// }

							if (
								!(
									action === 6 &&
									upperCoin !== 'INR' &&
									upperCoin !== 'TRY'
								)
							) {
								notify(
									<>
										<div
											className={`font-bold ${
												alertColors.get(alertType).text
											}`}
										>
											{title}
										</div>
										<div className="font-light text-gray-700 mt-2">
											{text}
										</div>
										{userAlertsCount > 1 && (
											<div className="mt-3">
												<Button
													variant="minimal"
													size="vtiny"
													onClick={openForYouTab}
												>
													+ {userAlertsCount - 1} more
												</Button>
											</div>
										)}
									</>,
									{
										icon: (
											<img
												src={icon}
												alt={title}
												height="25"
												width="25"
												className="rounded-full  -mb-8"
											/>
										),
										type: 'default',
										autoClose: false,
										onClose: () => {
											if (userAlertsCount === 1) {
												__setUserAlertsRead();
											}
											__setUserAlertLastShown(log_id);
											lastReadUserAlert = firstAlertTime;
											toastShown = false;
										},
										...(action === 4 && {
											toastClassNames:
												'border-l-4 border-green-600',
										}),
										...(action === 5 && {
											toastClassNames:
												'border-l-4 border-red-600',
										}),
										toastId: 'userAlerts',
									}
								);
							}
						}

						// if (
						// 	!notifShown &&
						// 	!tabInFocus &&
						// 	checkDocument &&
						// 	!toastShown
						// ) {
						// 	notifShown = true;
						// 	if (hasOwn(window, 'Notification')) {
						// 		const Notif = window.Notification;

						// 		try {
						// 			if (Notif.permission === 'granted') {
						// 				const notification = new Notif(title, {
						// 					body: text,
						// 					icon,
						// 					requireInteraction: true,
						// 					tag: 'ua',
						// 					renotify: true,
						// 				});
						// 				notification.onclick = function(e) {
						// 					window.focus();
						// 					if (links && links.length > 0) {
						// 						history.push(links[0].link);
						// 						e.preventDefault();
						// 						lastReadUserAlert = firstAlertTime;
						// 						__setUserAlertLastShown(log_id);
						// 						toastShown = false;
						// 						toast.dismiss('userAlerts');
						// 						notifShown = false;
						// 					}
						// 				};
						// 			}
						// 		} catch (err) {
						// 			console.log('userAlerts Notifs', err);
						// 		}
						// 	}
						// }

						const intentItems =
							depoCoin &&
							depoActionItems(depoCoin, selectedCountry);

						if (
							depoAction === 6 &&
							depoCoin !== 'INR' &&
							depoCoin !== 'TRY' &&
							depoCoin
						) {
							if (firstUserAlert && !hasIntent) {
								if (depoActionModal) {
									lastReadUserAlert = firstAlertTime;
									__setUserAlertLastShown(depoLogId);
									if (userAlertsCount === 1) {
										__setUserAlertsRead();
									}
									toastShown = false;
									depoActionModalStateChanger(false);
									notify(
										<>
											<p className="text-gray-300 font-bold">
												{title}
											</p>
											<p className="text-gray-300">
												{text}
											</p>
										</>
									);

									return null;
								}
							}

							return (
								<IntentModal
									openState={depoActionModal}
									intentItems={intentItems}
									upperContent={
										<div className="px-8 text-center mt-4 mb-12">
											<img
												src="https://bitbns.com/assets/img/Done.svg"
												alt="Done"
												height="70"
												width="75"
												className="inline-block"
											/>
											<h3 className="font-bold text-lg my-4">
												<Trans i18nKey="depositNotifModal.upperContent">
													{{ depoAmt }} {{ depoCoin }}{' '}
													deposited
													<br />
													to your Wallet
												</Trans>
											</h3>
										</div>
									}
									modalHeading={t(
										'depositNotifModal.heading',
										{
											depoCoin,
										}
									)}
									noBottom={intentItems.length === 0}
									bottomHeading={t(
										'depositNotifModal.bottomHeading'
									)}
									closer={() => {
										depoActionModalStateChanger(false);
										setTimeout(() => {
											// if (hasDepoSomewhere) {
											lastReadUserAlert = firstAlertTime;
											__setUserAlertLastShown(depoLogId);
											if (userAlertsCount === 1) {
												__setUserAlertsRead();
											}
											// }
											toastShown = false;
										}, 600);
									}}
								/>
							);
						}
					}
				} catch (err) {
					console.log(err);
				}
				return null;
			}
		)
	)
);

export default ({ openForYouTab }) => (
	<UserAlertsControlCenter openForYouTab={openForYouTab} />
);
